import styled from 'styled-components'
import { Border, Colors, Spacing, Typography } from '../../styles'
import { Icon, TIconType } from '../atoms/Icon'
import DetailsViewTemplate from '../templates/DetailsViewTemplate'

const EmptyMessage = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${Spacing._16};
    border: ${Border.stroke.medium} dashed ${Colors.background.border};
    border-radius: ${Border.radius.medium};
    background: ${Colors.background.panel};
    padding: ${Spacing._24};
`
const Text = styled.span`
    color: ${Colors.text.muted};
    ${Typography.title.large};
    text-align: center;
`

interface EmptyDetailsProps {
    icon: TIconType
    text: string
}

const EmptyDetails = ({ icon, text }: EmptyDetailsProps) => {
    return (
        <DetailsViewTemplate>
            <EmptyMessage>
                <Icon size="large" icon={icon} color="gray" />
                <Text>{text}</Text>
            </EmptyMessage>
        </DetailsViewTemplate>
    )
}

export default EmptyDetails
